/**
 * Modulo que encapsula los formateadores localizados de fechas.
 * Tiene formatos predeterminados en función del DATEFORMATS eligido.
 */

/**
 * # Documentación
 * https://date-fns.org/v2.23.0/docs/Time-Zones
 * https://www.npmjs.com/package/date-fns-tz
 *
 * Si en Greenwich son las 13h00:
 * - En Madrid son las 15h00 (+2)
 * - En Mexico son las 8h00  (-5)
 * - En Tokyo son las 22h00 (+9)
 */
// https://www.npmjs.com/package/date-fns-tz

import { formatFn as formatFnStandard } from '../formatFn';
import { parse } from './parse';

/**
 *
 * @param {Object} state
 * @param {Date} value
 * @param {string} dateFnsFormat el formateo, los valores posibles son los valores del DATEFORMATS datetime|datetimelong|date|time|timelong
 * @returns {string}
 */
export function formatFn(state, value, dateFnsFormat = 'PPPPpppp') {
  try {
    const timezonedDate = parse(state, value);
    return formatFnStandard(state, timezonedDate, dateFnsFormat);
  } catch (e) {
    console.error(e);
    return '';
  }
}
